import { render, staticRenderFns } from "./UpdateBoundingBoxCommand.vue?vue&type=template&id=ad2c8f6e"
import script from "./UpdateBoundingBoxCommand.vue?vue&type=script&lang=ts"
export * from "./UpdateBoundingBoxCommand.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports